// removed by extract-text-webpack-plugin
module.exports = {"wrap":"CwDoubleFilterList-wrap","buttons":"CwDoubleFilterList-buttons"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwdoublefilterlist/CwDoubleFilterList.scss
// module id = 365
// module chunks = 0